<template>
  <vf-button :size :variant @click="emit('click')">
    {{ $t.reserveInStore }}
  </vf-button>
</template>

<script lang="ts" setup>
export type Props = {
  reserved?: boolean
  variantId?: string
}

export type Emits = {
  'click': []
  'reserve': []
  'change-store': []
}

defineProps<Props>()

const emit = defineEmits<Emits>()

const { size, variant } = useAppConfig().components.product.cta
</script>
